import cn from 'clsx';

import { Skeleton } from '@/slw/shared/ui/skeleton';

const listOfSkeletons = [
  {
    image: false,
    edit: true,
  },
  {
    image: true,
    edit: false,
  },
  {
    image: false,
    edit: false,
  },
];

type ChatSkeletonProps = {
  visible: boolean;
};

export function ChatSkeleton({ visible }: ChatSkeletonProps) {
  return (
    <div className={cn('flex-col gap-3 md:gap-4', visible ? 'flex' : 'hidden')}>
      {listOfSkeletons.map(({ image, edit }, index) => (
        <SkeletonMessage image={image} edit={edit} key={index} />
      ))}
    </div>
  );
}

type SkeletonProps = {
  image?: boolean;
  edit?: boolean;
};

function SkeletonMessage({ image, edit }: SkeletonProps) {
  return (
    <li className='flex w-full gap-4'>
      <Skeleton className='h-10 w-10 shrink-0 rounded-full' />
      <div className='group flex flex-col w-full max-w-md gap-2'>
        <div className='flex items-center gap-2'>
          <Skeleton className='h-5 w-32' />
          <Skeleton className='h-4 w-24' />
        </div>
        <div className='flex flex-col gap-2'>
          {image ? <Skeleton className='h-40 w-full rounded-md' /> : <Skeleton className='h-24 w-full rounded-md' />}
          {edit && <Skeleton className='h-4 w-24 self-end' />}
        </div>
        <Skeleton className='h-4 w-32 self-end mt-1' />
      </div>
    </li>
  );
}
